import { RouterProvider } from 'react-router'
import { QueryProvider } from './providers'
import { ErrorBoundary } from '@/shared/lib'
import { router } from './router'

export function App() {
  return (
    <ErrorBoundary>
      <QueryProvider>
        <RouterProvider router={router} />
      </QueryProvider>
    </ErrorBoundary>
  )
}
